<div>
  <div class="segment-header" [class.with-divider]="showDivider" [class.mobile-flex-column]="mobileFlexColumn">
    <div class="main-content" *ngIf="text">
      <img *ngIf="iconUrl" [width]="iconSize" [height]="iconSize" [src]="iconUrl" [alt]="text" />
      <div class="texts">
        <h3 *ngIf="!useH2HeaderTag; else h2Title">{{ text }}</h3>
        <span *ngIf="subtext" [innerHTML]="subtext"></span>
      </div>
      <img *ngIf="iconUrlAfterTitle" [width]="iconSize" [height]="iconSize" [src]="iconUrlAfterTitle" [alt]="text" />
    </div>
    <div class="segment-header-content"><ng-content></ng-content></div>
  </div>
</div>

<div *ngIf="showDivider" class="ui divider horisontal"></div>

<ng-template #h2Title>
  <h2>{{ text }}</h2>
</ng-template>
